import { mapGetters } from 'vuex';
import mvtShifter from '@/common/components/mvtshifter/mvt-shifter.vue';

export default {
    name: 'mvtPageMenu',
    props: {
        menuType:{
            type: String,
            required: true,
            default(){
                return '';
            }
        },
        breadCrumb: {
            type: Array,
            default() {
                return [];
            }
        },
    },
    components: {
        mvtShifter,
    },
    data() {
        return {
            pageMenuList: []
        };
    },
    computed: {
        ...mapGetters('glb', ['glb']),
        getBreadCrumbData() {
            return this.breadCrumb;
        }
    },
    created() {
        let pageMenuArr = [{ 'url': this.glb.appUrl + 'sitemap/', 'text': 'Listings', 'gaEvent': 'LocalSubHeaderListingClick', 'selected': true }];
        pageMenuArr.push({ 'url': this.glb.appUrl + 'market-trends/', 'text': `${this.glb.isPhone ? '' : 'Market'} Trends`, 'gaEvent': 'LocalSubHeaderMarketTrendsClick' });
        pageMenuArr.push({ 'url': this.glb.appUrl + 'schools/', 'text': 'Schools', 'gaEvent': 'LocalSubHeaderSchoolsClick' });
        pageMenuArr.push({ 'url': this.glb.appUrl + 'sitemap/agents/', 'text': 'Agents'});
        pageMenuArr.push({ 'url': this.glb.appUrl + 'sitemap/rentals/', 'text': 'Rentals'});
        this.pageMenuList = pageMenuArr;
        this.pageMenuList.map( menu => {
            menu.selected = false;
            if(this.menuType.toLowerCase().indexOf(menu.text.toLowerCase())!==-1){
                menu.selected = true;
            }
        })
    }
};